import { CSSProperties, useMemo } from "react";
import { Column } from "@tanstack/react-table";

/**
 * Get the common styles for sticky positioning of pinned columns
 * Width is handled by CSS Grid, so only positioning is needed
 */
export const getCommonPinningStyles = <T>(column: Column<T>): CSSProperties => {
  const isPinned = column.getIsPinned();

  return {
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    position: isPinned ? "sticky" : "relative",
    zIndex: isPinned ? 1 : 0,
  };
};

export const useCommonPinningStyles = <T>(column: Column<T>): CSSProperties => {
  const left = column.getStart("left");
  const right = column.getAfter("right");
  const isPinned = column.getIsPinned();

  return useMemo(
    () => ({
      left: isPinned === "left" ? `${left}px` : undefined,
      right: isPinned === "right" ? `${right}px` : undefined,
      position: isPinned ? "sticky" : "relative",
      zIndex: isPinned ? 1 : 0,
    }),
    [left, right, isPinned],
  );
};
